// extracted by mini-css-extract-plugin
module.exports = {"SanityImage":"SanityImage_SanityImage__m6nBd","hasDataUri":"SanityImage_hasDataUri__TFqwC","loaded":"SanityImage_loaded__QhhIt"};